import type { PublicCommentUserCommentWithMeeting } from '@govinity/validation/public';

import { ReadOnlyApi } from './base';

export const PATH = '/public-comments';

class PublicCommentsApi extends ReadOnlyApi<PublicCommentUserCommentWithMeeting, never> {
  getPath() {
    return PATH;
  }
}

export default new PublicCommentsApi();
